<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="#d98880">
                            <v-toolbar-title class="my-0 py-0">Gestión de Transporte</v-toolbar-title>
                            <v-spacer></v-spacer>
                            EI 040
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <h6 color="black"><b>Datos del Cliente </b></h6>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="6">
                                    <h6> Razón Social: {{ codgral }} - {{ empresa }} </h6>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> N° de Orden de Compra: {{ codoc }} </h6>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> Fecha de Orden de Compra: {{ fecha }} </h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="8" md="10">
                                    <v-textarea dense v-model="descr" rows="2" auto-grow readonly outlined color="black"
                                        class="font-class-name"></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    <v-text-field dense v-model="cantidad" label="Catidad de Entregas" outlined readonly
                                        color="red darken-3"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2" md="2">

                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <!-- Tarjeta para mostrar cada elemento -->
                    <v-card>
                        <v-card-text>
                            <v-row dense v-for="(item, index) in listado" :key="index">
                                <v-col cols="12" md="12">
                                    <v-card>
                                        <v-card-text>
                                            <v-row dense>
                                                <v-col cols="12" sm="2" md="2">
                                                    Entrega: {{ item.entrega }}
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    Item: {{ item.item }}
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    Camión: {{ item.camion }}
                                                </v-col>
                                                <v-col cols="12" sm="1" md="1">
                                                    Bultos: {{ item.bultos }}
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    Detalle Bultos
                                                    <v-textarea dense v-model="item.detallebultos" outlined rows="2"
                                                        auto-grow color="black" readonly
                                                        class="font-class-bulto"></v-textarea>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                    <v-card color="#f2d7d5">
                                        <v-row dense>

                                            <v-col cols="12" sm="6" md="3">
                                                <h6><b> Transporte a cargo de ICSSA: </b> {{ item.transporte }}</h6>
                                                <h6><b> Seguro: </b> {{ item.seguro }}</h6>
                                                <h6><b> Descarga: </b> {{ item.descarga }}</h6>
                                                <h6><b> Lugar de Entrega: </b> {{ item.lugar }}</h6>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="2">
                                                <h6><b> Remito: </b> {{ item.remito }}</h6>
                                                <h6><b> Nota de Envío: </b> {{ item.nota }}</h6>
                                                <h6><b> Factura: </b> {{ item.factura }}</h6>
                                                <h6><b>Trasporte usado por el Cliente: </b> {{ item.transpcliente }}
                                                </h6>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="3">
                                                <h6><b>Fecha Necesidad (flete): </b> {{ item.fecha }}</h6>
                                                <h6><b>Monto de la Carga (U$S): </b> {{ item.montocarga }}</h6>
                                                <h6><b>Monto a Asegurar (U$S): </b> {{ item.montoasegurar }}</h6>
                                                <h6><b>Póliza: </b> 01-03-12-30009461</h6>
                                                <h6><b>Monto Asegurado: </b> U$S 200.000,00 + IVA</h6>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                                <h6><b>Detalle Remito: </b> {{ item.detalleremito }}</h6>
                                                <h6><b>Detalle Factura: </b> {{ item.detallefactura }}</h6>
                                                <h6><b>Costo Flete: </b> {{ item.costoflete }}</h6>
                                                <h6><b>Costo Descarga: </b> {{ item.costodescarga }}</h6>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="2" md="3">
                                                <v-text-field dense v-model="item.transporteabast"
                                                    label="Transporte Contratado" outlined
                                                    color="red darken-3"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="2" md="3">
                                                <v-text-field dense v-model="item.guiaabast" label="Guía de Despacho"
                                                    outlined color="red darken-3"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="2" md="3">
                                                <v-text-field dense v-model="item.fechaabast" label="Fecha envío"
                                                    outlined color="red darken-3"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="3">
                                                <v-select dense label="Estado Entrega" v-model="item.estadoabast"
                                                    :items="estados" item-text="nombre" item-value="valor" outlined
                                                    class="font-class-name" color="black"></v-select>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-select color="red darken-3" dense v-model="estado" :items="listadoestado"
                                        label="Estado" item-text="nombre" item-value="valor">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#d98880" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>
<style scoped>
.font-class-name {
    font-size: 14px;
}

.font-class-bulto {
    font-size: 11px;
}
</style>
<style lang="scss" scoped>
.v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;

    label {
        margin: 0 !important;
        margin-bottom: 0 !important;
    }

}

.v-textarea textarea {
    line-height: 0.5rem !important;
    margin: 1px;
}
</style>
<script>
import moment from "moment";
import axios from "../../axios-auth";
export default {
    data() {
        return {
            valid: false,
            lazy: false,
            empresa: "",
            provision: "",
            descr: "",
            fecha: "",
            cantidad: "",
            tipo: "",
            listado: [{ id: "0", entrega: "1", item: "", camion: "", bultos: "", estado: "", detallebultos: "" },
            ],
            listadodespacho: [],
            estado: "",
            listadoestado: [
                { nombre: 'Pendiente', valor: 'P' },
                { nombre: 'Cerrado', valor: 'C' },
            ],
            estados: [
                { nombre: 'Pendiente', valor: 'P' },
                { nombre: 'Cerrado', valor: 'C' },
            ],
            headers: [
                { text: "Entrega", value: "entrega", sortable: false, width: "5%" },
                { text: "Item", value: "item", sortable: false },
                { text: "Tipo y Cantidad de Camiones", value: "camion", sortable: false, width: "25%" },
                { text: "Total de Bultos", value: "bultos", sortable: false, width: "7%" },
                { text: "Estado", value: "estado", sortable: false, width: "15%" },

            ],
            deshabilitar: false,
            expanded: [],
            direcciones: [],
            direccion: "",
            correos: "",
            destinatarios: [],
            montoasegurado: "",
            poliza: ""
        };
    },

    props: ["visible", "codgral", "codoc"],
    computed: {

        show: {
            get() {
                if (this.visible == true) {
                    this.cargardatos();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarListado();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },

    },
    // created() {
    //     this.setExpanded(); // Inicializa el estado expanded
    // },
    // watch: {
    //     listado: {
    //         handler() {
    //             this.setExpanded(); // Actualiza expanded cuando listado cambia
    //         },
    //         deep: true // Si el listado tiene objetos que pueden cambiar
    //     }
    // },
    methods: {
        // setExpanded() {
        //     //this.expanded = this.listado.map(item => item.id); // Asegúrate de que cada item tenga un campo "id"
        //     this.expanded = this.listado.map((item, index) => index)
        //     console.log("exp", this.expanded)
        // },

        cargardatos() {
            const codgral = this.codgral;
            const codoc = this.codoc;
            let self = this;
            axios
                .get("/Lanzamiento/CargarAbastecimiento?", {
                    params: {
                        codgral: codgral,
                        codoc: codoc,
                    },
                })
                .then((response) => {
                    self.empresa = response.data.empresa;
                    self.provision = response.data.provision;
                    self.fecha = response.data.fecha;
                    self.estado = response.data.estado;
                    self.cantidad = response.data.cantidad;
                    self.tipo = response.data.tipo;
                    self.descr = response.data.descr;
                    self.listado = response.data.despacho;

                    //const entrega = self.listado.length + 1;
                    //if (self.listado.length == 0) {
                    //self.listado.push({ id: "0", entrega: entrega, item: "", camion: "", bultos: "", estado: "", detallebultos: "" },)
                    //}
                    //self.expanded = [0, 1, 2, 3, 4, 5, 6]
                    //self.setExpanded();
                }
                )
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },

        guardar() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Datos Transporte",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.listado.forEach((element) => {
                        if ((element.transporteabast != "" && element.transporteabast != null) || (element.guiaabast != "" && element.guiaabast != null) || (element.fechaabast != "" && element.fechaabast != null)) {
                            this.listadodespacho.push({
                                codgral: this.codgral,
                                codoc: this.codoc,
                                entrega: element.entrega,
                                transporteabast: element.transporteabast,
                                fechaabast: element.fechaabast,
                                guiaabast: element.guiaabast,
                                estadoabast: element.estadoabast,
                            });
                        }
                    });
                    var datos = {
                        codoc: this.codoc,
                        codgral: this.codgral,
                        empresa: this.empresa,
                        tipo: this.tipo,
                        estado: this.estado,
                        mail: this.direccion,
                        despacho: this.listadodespacho,
                    };

                    let self = this;
                    axios
                        .post("/Lanzamiento/GuardarAbastecimiento", datos)
                        .then((response) => {
                            //self.$refs.form.resetValidation();

                            self.showAlert({
                                icon: "success",
                                title: "Planilla guardada con éxito",
                                vm: self,
                            });
                            self.vaciarListado();
                            // setTimeout(() => {
                            //     self.$router.push({ name: "LanzamientoMain" });
                            // }, 5000);

                            self.$emit("close");
                        })
                        .catch({});
                }
            });
        },

        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 8000,
            });
        },

        vaciarListado() {
            this.empresa = "";
            this.fecha = "";
            this.provision = "";
            this.descr = "";
            this.tipo = "";
            this.cantidad = "";
            this.listado = [];
            this.listadodespacho = [];
            this.estado = "";
            this.direccion = "";
            this.correos = "";
            this.direcciones = [];
            this.deshabilitar = false;

        },
    },
};
</script>
